import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsFindBy } from 'services/WService.js';

export default WithApp(function ModalCuotaSupervisorPanettone(props) {
  const cuota = props.model;
  const periodo = moment(cuota.valueSearch?.Periodo).format('YYYY-MM');

  const [dataChanging, setDataChanging] = useState([]);
  const [zones, setZones] = useState([]);
  const [supervisors, setSupervisors] = useState([]);

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listSupervisors(codsede) {
    let response = await wsFindBy('base/supervisor-v2', { state: 'A', deleted: 'null', codsede: codsede });
    if (response.success) setSupervisors(response.data);
  }

  useEffect(() => {
    if (zones.length > 0 && cuota.base_zone_id) {
      handleChange('base_zone_id', String(cuota.base_zone_id));
    }
  }, [zones]);

  useEffect(() => {
    if (supervisors.length > 0 && cuota.base_supervisor_id) {
      handleChange('base_supervisor_id', String(cuota.base_supervisor_id));
    }
  }, [supervisors]);

  useEffect(() => {
    if (cuota.open) {
      setDataChanging({});
      listZones();
    }
  }, [cuota.open]);

  useEffect(() => {
    const sede = zones.find((z) => String(z.id) === String(dataChanging.base_zone_id));
    if (!sede?.code) {
      setSupervisors([]);
      return;
    }
    listSupervisors(sede.code);
  }, [dataChanging.base_zone_id, zones]);

  return (
    <>
      <Modal
        title={`Nueva cuota de supervisor Panetones`}
        model={cuota}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/panettone_supervisors'
        dataForce={{
          base_zone_id: dataChanging.base_zone_id,
          base_supervisor_id: dataChanging.base_supervisor_id,
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={zones}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Sede" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {
            handleChange('base_zone_id', item?.id);
            handleChange('base_supervisor_id', null);
          }}
          value={zones.find((zone) => String(zone.id) === String(dataChanging.base_zone_id)) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <Autocomplete
          disableClearable
          options={supervisors}
          getOptionLabel={(item) => `${item.name}`}
          renderInput={(params) => (
            <TextField {...params} label="Supervisor" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('base_supervisor_id', item?.id); }}
          value={supervisors.find((sup) => String(sup.id) === String(dataChanging.base_supervisor_id)) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <TextField
          label="Cuota (unidades)"
          fullWidth
          type="number"
          name="quota"
          margin="normal"
          defaultValue={!!cuota ? cuota.quota : ''}
          required
        />
      </Modal>
    </>
  );
});
